<template>
  <div class="row mb-2">
    <h5 v-if="hasDependencies">Essa função adiciona uma Mesa ao projeto.</h5>
    <div v-else>
      <h5 class="mb-5">Tudo certo com este projeto, sem pendências.</h5>
      <p class="mb-0 pb-2">Mesa: <strong>{{projeto.mesa}}</strong></p>
      <p class="mb-0 pb-2">Nota Projeto: <strong>{{projeto.avaliacao.avaliacao_projeto.nota}}</strong></p>
      <p class="mb-0 pb-2">Nota Resumo: <strong>{{projeto.avaliacao.avaliacao_resumo.nota}}</strong></p>

      <button @click="alteraNotas" class="btn btn-primary mt-5">Alterar notas</button>
    </div>
  </div>
  <div class="row">
    <div class="col-12" v-if="!projeto.mesa">
      <form-group label="Nome do Projeto" :is-invalid="errors.mesa">
        <input
          v-model="form.mesa"
          class="form-control mb-2"
          type="text"
          placeholder="Número da Mesa"
          :class="{'is-invalid' : errors.mesa}"
          maxlength="150"
        />
      </form-group>
    </div>

    <div class="col-6" v-if="!hasNotaProjeto || alterarNotas">
      <form-group label="Nota do Projeto">
        <input
          v-model="form.nota_projeto"
          type="number"
          @blur="verifyMaxMin('nota_projeto', 15)"
          max="15"
          min="0"
          class="form-control mb-2"
          placeholder="Nota do Projeto"
        />
      </form-group>
    </div>

    <div class="col-6" v-if="!hasNotaResumo || alterarNotas">
      <form-group label="Nota do Resumo">
        <input
          v-model="form.nota_resumo"
          max="20"
          @blur="verifyMaxMin('nota_resumo', 20)"
          class="form-control mb-2"
          type="number"
          placeholder="Nota do Resumo"
        />
      </form-group>
    </div>
  </div>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import axios from "axios";
import {success} from "../../Settings/toastr";

export default {
  props: ['projeto'],
  components: {
    FormGroup,
    FormBody
  },
  data: _ => ({
    model: {
      projeto: null,
    },
    form: {
      mesa: null,
      nota_projeto: null,
      nota_resumo: null
    },
    errors: {
      novo_avaliador: false,
    },
    alterarNotas: false,
    loading: false,
  }),

  created() {
    this.model.projeto = this.projeto.id

    if (!this.hasDependencies) {
      this.emitter.emit('hide-modal-success')
    }

    this.emitter.on('adiciona-pendencias', async function () {
      this.emitter.emit('loading-modal', true)

      await axios.post(this.route('app.projetos.adiciona_pendencias', {id: this.projeto.id}), this.form).then(result => {
        if (result.status === 201) {
          success('Pendências adicionadas ao projeto com sucesso!')

          this.emitter.emit('notas-changed', {
            projeto: result.data
          })

          this.emitter.emit('loading-modal', false)
          this.emitter.off('adiciona-pendencias')
        }
      })
    }.bind(this))
  },

  mounted() {
    $(this.$refs.select2).select2({
      dropdownParent: '#appModal'
    })
  },
  methods: {
    verifyMaxMin (index, max) {
      let value = this.form[index]

      if (value < 0) {
        this.form[index] = 0
      }

      if (value > max) {
        this.form[index] = max
      }
    },
    alteraNotas () {
      this.emitter.emit('show-modal-success')
      this.alterarNotas = true
    }
  },

  computed: {
    hasDependencies () {
      return !this.projeto.mesa || (!this.hasNotaProjeto || !this.hasNotaResumo)
    },
    hasNotaProjeto () {
      return this.projeto.avaliacao && !!this.projeto.avaliacao.avaliacao_projeto.nota
    },
    hasNotaResumo () {
      return this.projeto.avaliacao && !!this.projeto.avaliacao.avaliacao_resumo.nota
    }
  }
}
</script>
